import { render, staticRenderFns } from "./ImagemProdutoForm.vue?vue&type=template&id=56fe9fea&scoped=true&"
import script from "./ImagemProdutoForm.vue?vue&type=script&lang=js&"
export * from "./ImagemProdutoForm.vue?vue&type=script&lang=js&"
import style0 from "./ImagemProdutoForm.vue?vue&type=style&index=0&id=56fe9fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe9fea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
